import { Injectable } from '@angular/core';

import { environment } from '@customer-portal/environments';

@Injectable({ providedIn: 'root' })
export class TranslationUrlBuilder {
  buildBlobUrl(scope: string, lang: string): string {
    const basePath =
      scope === 'global'
        ? `${environment.translation.baseUrl}/global/${lang}.json`
        : `${environment.translation.baseUrl}/${scope}/${lang}.json`;

    return `${basePath}?${environment.translation.SAS}`;
  }

  buildAssetUrl(lang: string, scope?: string): string {
    return scope
      ? `./assets/i18n/${scope}/${lang}.json`
      : `./assets/i18n/${lang}.json`;
  }

  getNoCacheHeaders(): Record<string, string> {
    return {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    };
  }
}
